// extracted by mini-css-extract-plugin
export var container = "_aw-1";
export var cornerButtonContainer = "_aw-5";
export var disabled = "_aw-2";
export var fileContainer = "_aw-4";
export var hiddenInput = "_aw-3";
export var widthContainer = "_aw-0";